import React from 'react';
import { Link } from 'react-router-dom';
import SectorPage from '../components/SectorPage';
import Ticker from '../components/Ticker';

const SERIF = "'Newsreader', Georgia, serif";
const SANS  = "'Public Sans', -apple-system, BlinkMacSystemFont, sans-serif";
const GOLD  = '#c79a3a';
const SELF  = '/coverage/business-finance';

function SponsoredBand() {
  return (
    <div style={{ background: '#102030', marginTop: 34, position: 'relative', overflow: 'hidden' }} data-testid="baf-sponsored-band">
      <svg viewBox="0 0 400 80" preserveAspectRatio="xMaxYMax meet" style={{ position: 'absolute', right: 0, bottom: 0, height: '100%', opacity: 0.12, pointerEvents: 'none' }} aria-hidden="true">
        {[[0,20,18,60],[24,32,14,48],[44,14,20,66],[70,28,16,52],[92,8,22,72],[120,22,18,58],[144,36,14,44],[164,16,20,64],[190,30,16,50],[212,10,24,70],[242,24,18,56],[266,40,14,40],[286,18,20,62],[312,32,16,48],[334,6,22,74],[362,22,18,58],[386,38,14,42]].map(([x,y,w,h],i) => <rect key={i} x={x} y={y} width={w} height={h} fill="#fff"/>)}
      </svg>
      <div className="container-custom" style={{ paddingTop: 20, paddingBottom: 20, position: 'relative' }}>
        <div style={{ fontSize: 9, letterSpacing: '1.3px', textTransform: 'uppercase', color: '#5f7b8e', fontWeight: 700, marginBottom: 14 }}>Sponsored Content</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 32, flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 0', minWidth: 280 }}>
            <h2 style={{ fontFamily: SERIF, fontWeight: 500, fontSize: 28, lineHeight: 1.1, margin: '0 0 8px', color: '#fff' }}>Capital that Creates Communities</h2>
            <p style={{ fontSize: 13, color: '#8aa4b8', margin: '0 0 12px' }}>Investing locally. Hiring locally. Building a stronger economy together.</p>
            <Link to={SELF} style={{ color: GOLD, fontWeight: 600, fontSize: 13, textDecoration: 'none' }}>Learn More&nbsp;→</Link>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
            <span style={{ fontSize: 10, color: '#5f7b8e', letterSpacing: '1px', textTransform: 'uppercase' }}>Presented by</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ fontFamily: SANS, fontSize: 28, fontWeight: 700, color: '#fff', letterSpacing: '-0.5px', lineHeight: 1 }}>TRUIST</span>
              <span style={{ width: 28, height: 28, border: `2px solid ${GOLD}`, borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" aria-hidden="true"><line x1="8" y1="2" x2="8" y2="14"/><line x1="2" y1="8" x2="14" y2="8"/></svg>
              </span>
            </div>
            <span style={{ fontSize: 10.5, color: '#7fafc0', letterSpacing: '0.3px' }}>Purpose Drives Performance</span>
          </div>
        </div>
      </div>
    </div>
  );
}

const BUSINESS_FINANCE_CONFIG = {
  slug: 'business-finance',
  label: 'Business & Finance',
  selfPath: SELF,
  heroSlug: 'coverage/business-finance',
  h1Text: 'Business & Finance',
  h1Subtitle: 'Capital fuels possibility. Entrepreneurs build the future. Markets connect potential to progress.',
  h1Body: 'Independent reporting and smart analysis on markets, small business, investment, and the economic forces shaping opportunity.',
  briefingCtaText: "Read Today's Business Briefing",
  storiesCtaText: 'Explore Business & Finance Briefings',
  storiesAnchorId: 'sp-stories',
  gridLabel: 'Business & Finance Briefings',
  testId: 'business-finance-page',
  rightRailWidgets: [
    { type: 'video_of_week', duration: '6:37', title: 'The Outlook for Markets and Main Street', description: 'Experts weigh in on growth, inflation, and what investors should watch.' },
    { type: 'featured_company', badge: { text: 'Q2', bg: '#16304a', color: '#fff' }, name: 'Q2 Holdings, Inc.', description: 'Powering the future of digital banking and financial innovation.' },
    { type: 'executive_spotlight', initials: 'KS', name: 'Ken Siegel', title: 'CEO, First American Financial Corp.', description: 'Building trust, expanding opportunity, and driving long-term value.' },
    { type: 'market_pulse' },
    { type: 'cta_pair' },
    { type: 'leaving_soon' },
    { type: 'first_round_promo' },
  ],
};

export default function BusinessFinancePage() {
  return (
    <SectorPage
      config={BUSINESS_FINANCE_CONFIG}
      PulseBar={() => <Ticker scope="business-finance" />}
      SponsoredBand={SponsoredBand}
    />
  );
}
